export enum TypeErreurEnum {
  SYSTEME = 'CAAD.503300',
  AUTRE = 'CAAD.999999',
  PAS_DE_CARTE = 'CAAD.400001',
  PLUSIEURS_CARTES = 'CAAD.400002',
  STATUT_RISQUE = 'CAAD.400003',
  AFFAIRE_PRIVATIF = 'CAAD.400004',
  NON_MEMBRE = 'CAAD.400006',
  ADRESSE_DIFFERENTE = 'CAAD.400008',
  NUMEROCOMPTE = 'CAAD.400011',
  LIMITE_JOURNALIERE = 'CAAD.400012',
  ADRESSES_COMPTES_DIFFERENTES = 'CAAD.400013',
  COMPTE_TRANSFERT = 'CAAD.400014',
  SWITCH_MULTICOMPTE_CODETENTION = 'CAAD.400015',
  MIX_COMPTES_AFF_PRI_ORD = 'CAAD.400016',
  MEMBRE_PROCUREUR = 'CAAD.700121',
  MAX_FOLIO_BANCAIRE = 'CAAD.500122',
  ADRESSE_POSTALE_CIVIQUE_DIFFERENTE = 'CAAD.500123',
}
export default TypeErreurEnum;
